/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    headerTitle: 'Shop our <strong>Best Selling</strong> Flowers & Gifts for Every Occasion!',
    topsubHeaderTitle: '<strong>Need help deciding? </strong> Check out some of our favorite gifts below!',
    subHeader: [
        {
            subHeaderTitle: 'Birthday',
            subHeaderLink: '/birthdayflowers',
        },
        {
            subHeaderTitle: 'Plants',
            subHeaderLink: '/plants',
        },
        {
            subHeaderTitle: 'Sympathy',
            subHeaderLink: '/all-sympathy-flowers-and-gifts-13713',
        },
        {
            subHeaderTitle: 'Get Well',
            subHeaderLink: '/get-well-13715',
        },
        {
            subHeaderTitle: 'Love & Romance',
            subHeaderLink: '/love-and-romance-13712',
        },
    ],
    products: [
        {
            productUrl: '/party-pooch-167383',
            name: 'Party Pooch™',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/167383020619x.jpg?height=378&width=345',
                altText: 'Party Pooch',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '59.99',
                higherPrice: '64.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',

        },
        {
            productUrl: '/plants-classic-rose-101980',
            name: 'Classic Budding Rose',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/101980lyspx.jpg?height=378&width=345',
                altText: 'Classic Budding Rose',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '29.99',
                higherPrice: '59.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',

        },
        {
            productUrl: '/florist-delivered-healing-tears-blue-white-148683',
            name: 'Healing Tears™ Blue & White',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/148683lx.jpg?height=378&width=345',
                altText: 'Healing Tears Blue  White',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '49.99',
                higherPrice: '69.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',

        },
        {
            productUrl: '/doggie-howser-md-146761',
            name: 'Doggie Howser M.D.™',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/146761x.jpg?height=378&width=345',
                altText: 'Doggie Howser MD',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '59.99',
                higherPrice: null,
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/red-roses-24-stem-91790',
            name: 'Two Dozen Red Roses',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/90926mrdv4ch28x.jpg?height=378&width=345',
                altText: 'Two Dozen Red Roses',
                imageSnipe: {
                    imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/snipes/save10_z.gif?height=378&width=345',
                    altText: 'snipecorner',
                },
            },
            prices: {
                lowerPrice: '64.99',
                higherPrice: '88.99',
            },
            salePrices: {
                saleLowerPrice: '54.99',
                saleHigherPrice: '78.99',
            },
            deliveryOption: 'Shipped in a Gift Box',
        },
        {
            productUrl: '/florist-delivered-floral-embrace-167891',
            name: 'Floral Embrace™',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/167891lx.jpg',
                altText: 'Floral Embrace',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '49.99',
                higherPrice: '69.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',

        },
        {
            productUrl: '/bundle-of-love-rose-plant-157587',
            name: 'Bundle Of Love Rose Plant',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/157587lchx.jpg?height=378&width=345',
                altText: 'Bundle Of Love Rose Plant',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '34.99',
                higherPrice: '56.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',

        },
        {
            productUrl: '/sympathy/allwhitearrangement-95097',
            name: 'Classic All White Arrangement™  for Sympathy',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/95097lx.jpg?height=378&width=345',
                altText: 'Classic All White Arrangement for Sympathy',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '69.99',
                higherPrice: '89.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',

        },
        {
            productUrl: '/floral-melody-white-mosaic-vase-161273',
            name: 'Floral Melody™ in White Mosaic Vase',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/161273lx.jpg?height=378&width=345',
                altText: 'Floral Melody in White Mosaic Vase',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '54.99',
                higherPrice: '64.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/redrosecallalilybouquet-92930',
            name: 'Stunning Red Rose & Calla Lily Bouquet',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/92930srdv4ch27x.jpg?height=378&width=345',
                altText: 'Stunning Red Rose & Calla Lily Bouquet',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '59.99',
                higherPrice: '91.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',
        },
        {
            productUrl: '/birthday-wishes-flower-cake-vibrant-174313',
            name: 'Birthday Wishes Flower Cake® Vibrant',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/174313lbx.jpg?height=378&width=345',
                altText: 'Birthday Wishes Flower Cake Vibrant',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '39.99',
                higherPrice: '54.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/purple-hydrangea-in-mosaic-planter-18116',
            name: 'Hydrangea in Mosaic Planter',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/18116lcnx.jpg?height=378&width=345',
                altText: 'Hydrangea in Mosaic Planter',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '49.99',
                higherPrice: '74.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',
        },
        {
            productUrl: '/sympathy-healing-tears-lavender-white-148685',
            name: 'Healing Tears™ Lavender & White',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/148685lx.jpg?height=378&width=345',
                altText: 'Healing Tears Lavender & White',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '49.99',
                higherPrice: '69.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/florist-delivered-fields-of-europe-get-well-159225',
            name: 'Fields of Europe™ Get Well',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/159225xlx.jpg?height=378&width=345',
                altText: 'Fields of Europe Get Well',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '44.99',
                higherPrice: '74.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/plants-classic-rose-101980',
            name: 'Classic Budding Rose',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/101980lyspx.jpg?height=378&width=345',
                altText: 'Classic Budding Rose',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '29.99',
                higherPrice: '59.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',
        },
        {
            productUrl: '/florist-delivered-lovely-lavender-medley-167530',
            name: 'Lovely Lavender Medley™',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/167530lx.jpg?height=378&width=345',
                altText: 'Lovely Lavender Medley',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '54.99',
                higherPrice: '74.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/azalea-bonsai-18201',
            name: 'Azalea Bonsai',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/18201lwx.jpg?height=378&width=345',
                altText: 'Azalea Bonsai',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '44.99',
                higherPrice: '104.99',
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',
        },
        {
            productUrl: '/sympathy-sincerest-sorrow-blue-white-148693',
            name: 'Sincerest Sorrow™ Blue & White',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/148693lx.jpg?height=378&width=345',
                altText: 'Sincerest Sorrow Blue & White',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '109.99',
                higherPrice: '129.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',
        },
        {
            productUrl: '/florist-delivered-floral-embrace-167891',
            name: 'Floral Embrace™',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/167891lx.jpg',
                altText: 'Floral Embrace',
                imageSnipe: {},
            },
            prices: {
                lowerPrice: '49.99',
                higherPrice: '69.99',
            },
            salePrices: {},
            deliveryOption: 'Same-Day Local Florist Delivery',

        },
        {
            productUrl: '/personalized-message-in-a-bottle-139585',
            name: 'Personalized Message in a Bottle® Anniversary',
            image: {
                imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/139585s1x.jpg?height=378&width=345',
                altText: 'Personalized Message in a Bottle Anniversary',
                imageSnipe: {
                    imagePath: '//cdn1.1800flowers.com/wcsstore/Flowers/images/catalog/snipes/personalizethis_z.gif?height=378&width=345',
                    altText: 'personalize',
                },
            },
            prices: {
                lowerPrice: '39.99',
                higherPrice: null,
            },
            salePrices: {},
            deliveryOption: 'Shipped in a Gift Box',
        },
    ],

};
export default data;
